/**
 * /frontend/src/features/membership/utils/membershipCsv.ts
 *
 * Maps membership member rows to flat CSV rows for the "Export members"
 * download. Column key order here is the column order in the exported file.
 */

import type { MembershipMemberRow } from '../api/membership.api';

const formatDate = (value?: string | null): string => {
  if (!value) return '';
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return String(value);
  return parsed.toLocaleDateString();
};

const numberOrBlank = (value?: number | null): string =>
  value === null || value === undefined || Number.isNaN(Number(value)) ? '' : String(value);

/**
 * Turns member rows into ordered CSV row objects.
 */
export const membersToCsvRows = (members: MembershipMemberRow[]): Array<Record<string, string>> => {
  const list = Array.isArray(members) ? members : [];
  return list.map((member) => ({
    Name: member.userName || '',
    Phone: member.phone || '',
    Email: member.email || '',
    Tier: member.membershipTypeName || '',
    Status: member.status || '',
    'Points balance': numberOrBlank(member.pointsBalance),
    'Total visits': numberOrBlank(member.totalVisits),
    'Benefit type': member.benefitType || '',
    'Included visits': numberOrBlank(member.includedVisits),
    'Visits used': numberOrBlank(member.visitsUsed),
    'Visits remaining': numberOrBlank(member.visitsRemaining),
    'Issued on': formatDate(member.issuedAt),
    'Starts on': formatDate(member.startsAt),
    'Expires on': formatDate(member.expiresAt),
    'Last visit': formatDate(member.lastVisitedAt),
    'Membership ID': member.membershipUuid || ''
  }));
};

/** Download filename for the members export. */
export const membersCsvFilename = (): string =>
  `memberships_${new Date().toISOString().slice(0, 10)}.csv`;
